/**
 * Authorization Module
 *
 * Centralized exports for authorization APIs
 *
 * This module provides three ways to check permissions:
 *
 * 1. Imperative API (authzClient.can):
 *    - For programmatic checks in event handlers or async functions
 *    - Returns a Promise<boolean>
 *
 * 2. Hook API (useCan):
 *    - For use in React components
 *    - Returns [boolean, queryState] tuple
 *    - Automatically subscribes to permission changes
 *
 * 3. Component API (<Can>):
 *    - For conditional rendering in JSX
 *    - Supports loading and no-access fallbacks
 *    - Uses useCan hook internally
 *
 * All three APIs share the same react-query cache for consistency.
 */

// Imperative API
export { authzClient } from './AuthzClient';
export type { AuthzClient } from './AuthzClient';

// Hook and Component API
export { useCan, Can } from '@/hooks/useCan';
